import React from "react";

type FilterFieldProps = {
    label: string;
    children: React.ReactNode;
};

const FilterField: React.FC<FilterFieldProps> = ({ label, children }) => (
    <div className="flex w-full min-w-0 flex-col gap-1.5">
        <span className="px-1 text-xs font-bold uppercase leading-4 tracking-wide text-gray-500">{label}</span>
        {children}
    </div>
);

export default FilterField;
